export default __webpack_public_path__ + "static/media/oklogo.8ebb5503.png";